import { SelectProps } from "antd";
import { ReactNode } from "react";
import { SelectItemTagRender } from "src/content/tools/alerting/AlertingHistory";
import { GLOB } from "src/util/Glob";
import { XmSelect } from "./XmSelect";
import './select.less';

interface XmTagReadOnlySelectProps extends Omit<SelectProps, 'value' | 'options'> {
  tags: string[];
  /** Custom dropdown option content for a tag; defaults to the tag itself */
  optionLabel?: (tag: string) => ReactNode;
}

const XmTagReadOnlySelect = ({ tags = [], optionLabel, ...props }: XmTagReadOnlySelectProps) => (
  <XmSelect
    className="xm-tags-read-only-select"
    classNames={{ popup: { root: "xm-select-readonly" } }}
    mode='multiple'
    popupMatchSelectWidth={true}
    maxTagCount='responsive'
    style={{ width: '100%' }}
    menuItemSelectedIcon={null}
    removeIcon={null}
    size="small"
    suffixIcon={null}
    tagRender={SelectItemTagRender}
    variant="borderless"
    {...props}
    getPopupContainer={() => document.body}
    showSearch={{ optionFilterProp: 'value' }}
    value={tags.sort((a, b) => GLOB.naturalSort(a, b))}
    options={tags.map(t => ({
      value: t,
      label: <div className='xm-tree-title'>{optionLabel ? optionLabel(t) : t}</div>,
    }))}
    ignoreReadonly
  />
);

export default XmTagReadOnlySelect;